const constants = {
    navbarPinnedClass: 'cloud-navbar-pinned',
    fortModuleId: 33,
};
export default constants;
